"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteType = void 0;
var RouteType;
(function (RouteType) {
    // 正常跳转
    RouteType[RouteType["Change"] = 0] = "Change";
    // 会话过期
    RouteType[RouteType["Expired"] = 1] = "Expired";
    // 多 tab 切换
    RouteType[RouteType["MultiTab"] = 2] = "MultiTab";
})(RouteType = exports.RouteType || (exports.RouteType = {}));
